import React from 'react';
import {Alert, Box, Grid, Typography} from '@deere/fuel-react';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {useStyles} from "../shared/styles/Ratings";
import {RatingsActions} from "./RatingsActions";
import {LAST_UPLOADED_DATE, NO_DATA} from "../shared/Constants";
import {RatingObjectiveQPPMDetails} from "./RatingObjectiveQPPMDetails";
import {toCapitalizeSplitStr, shouldDefaultToNA} from "../shared/utils";

export const RatingObjective = ({
                                    criteria,
                                    isActionsAllowed,
                                    suppliers,
                                    functionalAreaId,
                                    onNotApplicableClick,
                                    isNotApplicableEdit,
                                    isSupplierMimic,
                                    chartData
                                }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const isQuantitativeDataPresent = criteria.quantitativeData && criteria.quantitativeData.length > 0
    const path = process.env.REACT_APP_ALL_SUPPLIERS_DISPLAY_CHARTS;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleNotApplicable = (type) => {
        onNotApplicableClick(criteria.id, type);
        setAnchorEl(null);
    }

    return (
        <Grid container alignItems="center">
            <Grid item xs={12} md={8}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{
                        expandIcon: classes.expandIcon,
                        content: classes.content,
                        expanded: classes.expanded
                    }}
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    IconButtonProps={suppliers.length < 2 && !chartData?.[suppliers[0].supplierNumber] ? {className: classes.btn} : {}}
                    >
                    {functionalAreaId !== 2 && !criteria.criteria.includes("QPPM") &&
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box display="flex"
                                     justifyContent="flex-start"
                                     alignItems="center">
                                    <Typography
                                        color="primary" size="md"
                                        style={suppliers.length < 2 ? {
                                            paddingLeft: '10px',
                                            paddingRight: '2rem'
                                        } : {paddingLeft: '0px', paddingRight: '2rem'}}>
                                        {criteria.criteria}
                                        {criteria.isRequired ? (
                                            <span style={{
                                                marginLeft: ".25rem",
                                                display: "inline"
                                            }}
                                                  aria-label="required field"
                                                  className="uxf-is-required"
                                            > * </span>
                                        ) : ""}
                                    </Typography>
                                    {/*<>*/}
                                    {/*    {suppliers.length < 2 && (criteria.criteria.includes("DPPM") || criteria.criteria.includes("QIPM")) &&*/}
                                    {/*        <Link href={path} target="_blank"*/}
                                    {/*              rel="noopener noreferrer">{VIEW_PERFORMANCE_GRAPH}*/}
                                    {/*        </Link>*/}
                                    {/*    }*/}
                                    {/*</>*/}
                                </Box>
                            </Grid>
                            {criteria.errorMsg !== "" &&
                                <Grid item xs={12}>
                                    <Alert variant="warning" title={criteria.errorMsg}/>
                                </Grid>
                            }
                        </Grid>
                    }
                    {functionalAreaId !== 2 && criteria.criteria.includes("QPPM") &&
                        <Box display="flex"
                             justifyContent="flex-start"
                        >
                            <>
                                {suppliers.length < 2 ?
                                    <RatingObjectiveQPPMDetails
                                        title={criteria.criteria}
                                        isRequired={criteria.isRequired}
                                        qbicName={isQuantitativeDataPresent && criteria.quantitativeData[0].qbicName}
                                        quartile={isQuantitativeDataPresent && criteria.quantitativeData[0].quartile}
                                        path={path}/>
                                    :
                                    <Typography
                                        color="primary" size="md"
                                        style={suppliers.length < 2 ? {
                                            paddingLeft: '10px',
                                            paddingRight: '2rem'
                                        } : {paddingLeft: '0px', paddingRight: '2rem'}}>
                                        {criteria.criteria}
                                        {criteria.isRequired ? (
                                            <span style={{
                                                marginLeft: ".25rem",
                                                display: "inline"
                                            }}
                                                  aria-label="required field"
                                                  className="uxf-is-required"
                                            > * </span>
                                        ) : ""}
                                    </Typography>
                                }
                            </>
                        </Box>
                    }
                    {functionalAreaId === 2 &&
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box display="flex"
                                     justifyContent="flex-start"
                                     alignItems="center">
                                    <Typography
                                        color="primary" size="md"
                                        style={suppliers.length < 2 ? {
                                            paddingLeft: '10px',
                                            paddingRight: '2rem'
                                        } : {paddingLeft: '0px', paddingRight: '2rem'}}>
                                        {criteria.criteria}
                                        {criteria.isRequired ? (
                                            <span style={{
                                                marginLeft: ".25rem",
                                                display: "inline"
                                            }}
                                                  aria-label="required field"
                                                  className="uxf-is-required"
                                            > * </span>
                                        ) : ""}
                                    </Typography>
                                    {/*<>*/}
                                    {/*    {suppliers.length < 2 && (criteria.criteria.includes("DPPM") || criteria.criteria.includes("QIPM")) &&*/}
                                    {/*        <Link href={path} target="_blank"*/}
                                    {/*              rel="noopener noreferrer">{VIEW_PERFORMANCE_GRAPH}*/}
                                    {/*        </Link>*/}
                                    {/*    }*/}
                                    {/*</>*/}
                                </Box>
                            </Grid>
                            {criteria.errorMsg !== "" &&
                                <Grid item xs={12}>
                                    <Alert variant="warning" title={criteria.errorMsg}/>
                                </Grid>
                            }
                        </Grid>
                    }
                </AccordionSummary>
            </Grid>
            <Grid item xs={12} md={4}>
                <Box m={2} display="flex" alignItems="center" justifyContent="flex-end">
                    <Grid container justifyContent="flex-end">
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <Box display="inline-flex" flexDirection="column" justifyContent="flex-end">
                                    {(suppliers.length > 1 || (criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].lastUpdateDate === "")) ?
                                        <>
                                            <Grid item xs={12}>
                                                <Box display="flex"
                                                     justifyContent="flex-end" pl={1} pr={1}>
                                                    <Typography
                                                        size="3xl"
                                                        display="inline">
                                                        {criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].groupPoints !== null ? toCapitalizeSplitStr(criteria.quantitativeData[0].groupPoints) : ""}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            {(criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].groupPoints !== null &&
                                                    <Grid item xs={12}>
                                                        <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2}
                                                             pb={2}>
                                                            <Typography color="tertiary" size="sm">
                                                                {criteria.label ?? ""}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>)
                                                || (criteria.quantitativeData &&
                                                    <Grid item xs={12}>
                                                        <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2}
                                                             pb={2}>
                                                            <Typography color="tertiary" size="sm">
                                                                {NO_DATA}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>)
                                            }
                                        </>
                                        :
                                        <>
                                            <Grid item xs={12}>
                                                <Box display="flex"
                                                     justifyContent="flex-end" pl={1} pr={1}>
                                                    <Typography
                                                        size="3xl"
                                                        display="inline">
                                                        {criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].groupPoints !== null ? toCapitalizeSplitStr(criteria.quantitativeData[0].groupPoints) : ""}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            {(criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].groupPoints !== null &&
                                                    <Grid item xs={12}>
                                                        <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2}
                                                             pb={2}>
                                                            <Typography color="tertiary" size="sm" style={{ marginLeft: '-180px' }}>
                                                                {LAST_UPLOADED_DATE}: {criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].lastUpdateDate} {criteria.label ? (", " + criteria.label) : ""}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>)
                                                || (criteria.quantitativeData &&
                                                    <Grid item xs={12}>
                                                        <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2}
                                                             pb={2}>
                                                            <Typography color="tertiary" size="sm">
                                                                {NO_DATA}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>)
                                            }
                                        </>
                                    }
                                </Box>
                                {criteria.quantitativeData && criteria.quantitativeData.length > 0 && criteria.quantitativeData[0].groupPoints && criteria.quantitativeData[0].groupPoints !== null ?
                                    <Box display="flex" pr={2} pt={2}
                                         justifyContent="center">
                                        <Typography size="lg"
                                                    display="inline">|</Typography>
                                    </Box>
                                    : <></>
                                }
                                {criteria.notApplicableReason || shouldDefaultToNA(criteria) ?
                                    <Box display="inline-flex" flexDirection="column" alignSelf="center"
                                         justifyContent="flex-end">
                                        <Grid item xs={12}>
                                            <Box display="flex"
                                                 justifyContent="center" alignItems="center" pl={1} pr={1}>
                                                <Typography size="xl" fontWeight={"semibold"}
                                                            display="inline">
                                                    N/A
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Box>
                                    :
                                    <Box display="inline-flex" flexDirection="column" justifyContent="flex-end">
                                        <Grid item xs={12}>
                                            <Box display="flex"
                                                 justifyContent="center" pl={1} pr={1}>
                                                <Typography size="xl" fontWeight={"semibold"}
                                                            display="inline">
                                                    {criteria.points !== null ? criteria.points : "-"}/{criteria.weightage}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center" pl={1} pr={1} pt={2}
                                                 pb={2}>
                                                <Typography color="tertiary" size="sm">
                                                    Points
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Box>
                                }
                                {(isActionsAllowed && !isSupplierMimic) &&
                                    <RatingsActions
                                        onClose={handleClose}
                                        onActionsClick={handleClick}
                                        anchorEl={anchorEl}
                                        isRequired={criteria.isRequired}
                                        isObjective={true}
                                        onNotApplicableClick={handleNotApplicable}
                                        notApplicableEdit={isNotApplicableEdit}/>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    )
}
